import { z } from "zod";

/**
 * Telefone brasileiro — aceita com ou sem formatação.
 * Normaliza para apenas dígitos (10 ou 11 chars).
 */
export const phoneBRSchema = z
  .string()
  .trim()
  .transform((v) => v.replace(/\D/g, ""))
  .refine((v) => v.length === 10 || v.length === 11, "Telefone deve ter 10 ou 11 digitos");

export const optionalPhoneBRSchema = z
  .string()
  .trim()
  .optional()
  .transform((v) => (v ? v.replace(/\D/g, "") : undefined))
  .refine(
    (v) => v === undefined || v.length === 10 || v.length === 11,
    "Telefone deve ter 10 ou 11 digitos",
  );
